import { decode } from 'html-entities';

export function escapeSocialFeedText(text) {
  return text.replace(/[&<>]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;',
  }[char]));
}

export function getSocialFeedText(text) {
  let result = text || '';

  // Accept raw HTML and entity-encoded feed markup, with bounded decoding.
  for (let layer = 0; layer < 2; layer += 1) {
    const decoded = decode(result.replace(/&#(x[0-9a-f]+|[0-9]+);/gi, (match, value) => {
      const codePoint = value[0].toLowerCase() === 'x'
        ? parseInt(value.slice(1), 16) : parseInt(value, 10);
      return codePoint > 0 && codePoint <= 0x10ffff && !(codePoint >= 0xd800 && codePoint <= 0xdfff)
        ? String.fromCodePoint(codePoint) : '\ufffd';
    }));
    result = decoded;
  }

  // This produces text only; callers must still escape it before using v-html.
  return result
    .replace(/<!--[^]*?-->/g, ' ')
    .replace(/<(script|style)\b[^>]*>[^]*?<\/\1\s*>/gi, ' ')
    .replace(/<\/?[a-z](?:"[^"]*"|'[^']*'|[^'">])*>/gi, ' ')
    .replace(/[\s\u2800]+/g, ' ')
    .trim();
}
